import './Contacto.css';

const Contacto = () => {

  return (
    <main className="contacto-page">

      <div className="contacto-wrapper">

        <div className="contacto-header">

          <span className="contacto-badge">
            📩 SOPORTE
          </span>

          <h1>Contáctanos</h1>

          <p>
            ¿Tienes dudas, sugerencias o problemas con tu cuenta?
            Nuestro equipo estará encantado de ayudarte.
          </p>

        </div>

        <div className="contacto-card">

          <div className="contacto-group">
            <label>Nombre completo</label>
            <input
              type="text"
              placeholder="Ingresa tu nombre"
            />
          </div>

          <div className="contacto-group">
            <label>Correo electrónico</label>
            <input
              type="email"
              placeholder="ejemplo@correo.com"
            />
          </div>

          <div className="contacto-group">
            <label>Asunto</label>
            <input
              type="text"
              placeholder="Motivo de contacto"
            />
          </div>

          <div className="contacto-group">
            <label>Mensaje</label>
            <textarea
              rows="7"
              placeholder="Escribe tu mensaje..."
            ></textarea>
          </div>

          <button className="btn-contacto">
            Enviar mensaje
          </button>

        </div>

      </div>

    </main>
  );
};

export default Contacto;